/* global Swiper bodymovin Waypoint */
/*
 * Swiper for customer quotes in hero
 */
(function () {
	"use strict";

	new Swiper('.heroBox .swiper-container', {
		// Optional parameters
		loop: true,

		// If we need pagination
		pagination: {
			el: '.heroBox .swiper-pagination',
			clickable: true
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true
		},
	});

}());

// Cloud agents animation
// https://github.com/airbnb/lottie-web
// animation data is exported from Adobe After Effects
(function () {
	function loadAnimation(elementId, data) {
		return bodymovin.loadAnimation({
			container: document.getElementById(elementId),
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: data
		});
	}

	// animation 1
	var animation1 = loadAnimation('cloud-agents', '/asset/data/animation1.json');
	var animationStarted1 = false;
	var heroContent = document.querySelector(".heroContent") || null;

	heroContent.addEventListener("heroContentComplete", function () {
		if (!animationStarted1) {
			animation1.play();
			animationStarted1 = true;
		}
	});

	// when animation 1 (above the fold) has been downloaded, only then download and run the other animations (below the fold)
	animation1.addEventListener("data_ready", function () {
		function setWaypointAndAnimation(elementId, offset, animation) {
			var animationStarted = false;

			new Waypoint({
				element: document.getElementById(elementId),
				offset: offset,
				handler: function(direction) {
					if (direction === "down" && !animationStarted) {
						animation.play();
					}

					animationStarted = true;
				}
			});
		}

		// animation 2
		var animation2 = loadAnimation('cloud-agent', '/asset/data/animation2.json');
		setWaypointAndAnimation('beyond-traditional', "80%", animation2);

		// animation 3
		var animation3 = loadAnimation('three-agents', '/asset/data/animation3.json');
		setWaypointAndAnimation('millions-cloud-agents', "60%", animation3);

		// animation 4
		var animation4 = loadAnimation('scanners-worldwide', '/asset/data/animation4.json');
		setWaypointAndAnimation('scanners-worldwide', "60%", animation4);
	});
}());